export default "https://cdn.questicon.mathletics.com/assets/images/Guide-74114953406a07a8364ebcbce83e4b23.png";